module.exports = __webpack_public_path__ + "img/Smart-Farming.80247116.png";